export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_CRITERE = 'SET_CRITERE';
export const SET_CRITERE_RECHERCHE_COMMUN = 'SET_CRITERE_RECHERCHE_COMMUN';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_RETOUR_DETAIL = 'SET_RETOUR_DETAIL';
